import * as React from 'react';
import { graphql } from 'gatsby';
import { createGatsbyPageComponent } from '@shapeable/ui';
import { transformTopic } from '../../utils/transforms';
import { TopicPrintLayout } from '../../components/entities/topic-print-layout';

export default createGatsbyPageComponent('Topic', { layout: TopicPrintLayout, transform: transformTopic });

export const topicQuery = graphql`
  query TopicPdfQuery($id: ID!) {
    platform {
      topic(id: $id) {
        id slug name path __typename
        created
        published
        doiId
        outlineNumber
        trend { id path slug name __typename }
        description { text }
        intro { text }
        anticipatoryImpact { text }
        indicatorValues {
          id value numericValue year
          indicator { id name title slug dataSetId color { id value } }
        }
        editions { id name slug numericValue }
        anticipatoryImpactImage { 
          image {
            id
            url
          }
        }
        embeds {
          citations {
            id slug url name authors { id name slug } 
            authorShowsEtAl edition publication accessDate 
            startPage volume footnoteNumber year
          }
          imageAssets {
            id
            slug
            image {
              id url url2x width height type 
            }
          }
        }
        surveyObservations { text }
        color { id name slug value darkValue veryDarkValue }
        banner {
          id
          name
          description { text }
          license {
            id
            name
            url
            description { text }
          }
          image {
            id
            url
            width
            height
            thumbnails { mainBanner { url url2x } }
          }
        }
        trend {
          id name slug __typename
          outlineNumber
          openGraph { image { thumbnails { card {url } } } }
          color { id name slug value }
        }
        chartImage { 
          id
          slug
          image { 
            id url url2x
          }
        }
        citations {
          __typename _schema { label pluralLabel }
          typeLabel
          slug url name authors { id name slug } 
          authorShowsEtAl edition publication accessDate 
          startPage volume footnoteNumber year
        }
        subTopics {
          id name path outlineNumber slug __typename 
          color { id name value }
          topic { id slug path }
          intro { text }
          description { text }
          anticipationScores { text }
          anticipationScoresImage {
            id
            image {
              id url url2x width height
            }
          }
          horizons {
            __typename id name slug
            intro { text }
            description { text }
            color { __typename id name slug value }
            type { __typename id name slug years title subtitle }
            embeds {
              citations {
                slug url name authors { id name } authorShowsEtAl edition publication accessDate startPage volume footnoteNumber year
              }
            }
          }
          indicatorValues {
            id value numericValue year
            indicator { id name title slug dataSetId color { id value } }
          }
          embeds {
            citations {
              slug url name authors { name } authorShowsEtAl edition publication accessDate startPage volume footnoteNumber year
            }
            imageAssets {
              id
              slug
              image {
                id url url2x width height type 
              }
            }
          }
        }
        committeeMembers {
          __typename id name slug position path
          badge
          color { value }
          topicExpertise {
            id name slug editions { id name slug }
            topic { id }
          }
        }
        committeeChairs {
          __typename id name slug position path
          openGraph { id title image { id url url2x thumbnails { card { id url url2x } } } }
          organisation { id name slug }
          topicExpertise {
            id name slug editions { id name slug }
            topic { id }
          }
        }
      }
    }
  }
`;
